import DashboardLayout from "../layouts/dashboard";

import SkillInfoIndexPage from "../views/skillInfo";
import SkillInfoCreatePage from "../views/skillInfo/skillInfoCreate";
import SkillInfoDetailPage from "../views/skillInfo/skillInfoDetail";
import SkillInfoImportPage from "../views/skillInfo/skillInfoImport";

import { auth } from "./routerHelper";

const routes = {
  path: "/",
  element: <DashboardLayout />,
  children: [
    {
      path: "skill_infos",
      element: auth(<SkillInfoIndexPage />),
    },
    {
      path: "skill_info/create",
      element: auth(<SkillInfoCreatePage />),
    },
    {
      path: "skill_info/import",
      element: auth(<SkillInfoImportPage />),
    },
    {
      path: "skill_info/:skillId",
      element: auth(<SkillInfoDetailPage />),
    },
  ],
};

export default routes;
